// Driver analytics event bit definitions, palette, and helpers.
// Bit layout matches the firmware message header (rev 6), the gateway
// proto, the trip_routes.da_event_flags column and the matching palette
// in the personal web and the mobile app.
//
// priority orders the events when more than one bit is set on a single
// emit: the highest-priority event wins the segment colour. Per-event
// detail still surfaces in the label list and the badge icons.

export const DA_EVENT_BITS = [
    { mask: 0x08, label: 'Crash',       color: '#000000', icon: 'mdi-car-emergency',     priority: 5 },
    { mask: 0x02, label: 'Harsh brake', color: '#E53935', icon: 'mdi-car-brake-alert',   priority: 4 },
    { mask: 0x04, label: 'Harsh accel', color: '#8E24AA', icon: 'mdi-rocket-launch',     priority: 3 },
    { mask: 0x01, label: 'Hard turn',   color: '#FF6F00', icon: 'mdi-steering',          priority: 2 },
    { mask: 0x10, label: 'Speeding',    color: '#FB8C00', icon: 'mdi-speedometer',       priority: 1 },
];

// Fallback colour for the any-event case. Prefer the primary event's
// own colour when one is available.
export const COLOR_DA_EVENT_FALLBACK = '#E53935';

export const daEventBitsSet = (flags) => {
    const f = Number(flags) || 0;
    if (!f) return [];
    return DA_EVENT_BITS.filter(b => f & b.mask);
};

export const daEventLabels = (flags) => daEventBitsSet(flags).map(b => b.label).join(', ');

export const primaryDaEvent = (flags) => {
    const set = daEventBitsSet(flags);
    if (!set.length) return null;
    return set.reduce((a, b) => (a.priority >= b.priority ? a : b));
};
